import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FaqService } from './faq.service';
import { JwtHelperService } from '@auth0/angular-jwt';

@Component({
    selector: 'sc-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.scss']
})

export class FaqComponent implements OnInit {

    questions: any;
    token: string;
    public jwtHelperService: JwtHelperService = new JwtHelperService();
    user: string;

    constructor(public faqService: FaqService,
        private router: Router) {
    }

    ngOnInit() {
        this.token = localStorage.getItem('tk');
        this.user = this.token && this.jwtHelperService.decodeToken(this.token);
        if (!this.user) {
            this.router.navigate(['forbidden']);
        }
        this.faqService.getQuestions().subscribe(
            (response : any) => {
                let data = response.data;
                this.questions = data.grupos[0].preguntas;
            }
        );
    }
}